import { Navigation } from "./Navigation";
import { AutoTranslateSlider } from "./AutoTranslateSlider";
import ScrollToTop from "./ScrollToTop";
import { ContentImageTextSlider } from "./ContentImageTextSlider";
import { AsideNavigation } from "./AsideNavigation";
import { Search } from "./Search";
import Overlay from "./Overlay";
import { horizontallyScrollElementIntoView } from "./helpers/horizontallyScrollElementIntoView";
import { NewsSlider } from "./NewsSlider";
import { Dialog } from "./Dialog";
import "./SkipSection";
import "./Calendar";

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

new Navigation();
new AsideNavigation();
new Search();
new ContentImageTextSlider();

const certificateSections = document.querySelectorAll(".certificates-section");
certificateSections.forEach((container: HTMLElement) => {
    new AutoTranslateSlider(container);
});

const backToTopButton = document.querySelector<HTMLElement>(".back-to-top");
if (backToTopButton) {
    new ScrollToTop(backToTopButton);
}

const overlaySections = document.querySelectorAll(".lending-rules");
overlaySections.forEach((container: HTMLElement) => {
    new Overlay(container);
});

const newsSections = document.querySelectorAll(".news-section .swiper");
newsSections.forEach((container: HTMLElement) => {
    new NewsSlider(container);
});

// scroll open nav-chapter link into view (if any active)
horizontallyScrollElementIntoView(document.querySelector(".nav-chapter-item.open"));

const showDialogButtons = document.querySelectorAll("button[data-dialog-id]");
showDialogButtons.forEach((showDialogButton: HTMLButtonElement) => {
    new Dialog(showDialogButton);
});
